__turbopack_context__.v({
  "card": "_dGxrq_card",
  "catalog": "_dGxrq_catalog",
  "container": "_dGxrq_container",
  "count": "_dGxrq_count",
  "group": "_dGxrq_group",
  "groupCards": "_dGxrq_groupCards",
  "groupTitle": "_dGxrq_groupTitle",
  "groupTitleCount": "_dGxrq_groupTitleCount",
  "variant--embed": "_dGxrq_variant--embed",
});
